import styled, { css } from 'styled-components';

import * as vr from 'core/styles/variables';

export const Wrapper = styled.section<{
	margin?: string;
	padding?: string;
	hasBorderTop?: boolean;
	hasBorderBottom?: boolean;
	customCss?: string;
}>`
	${({ margin }) =>
		!!margin &&
		css`
			margin: ${margin};
		`}

	${({ padding }) =>
		!!padding &&
		css`
			padding: ${padding};
		`}

	${({ hasBorderTop }) =>
		!!hasBorderTop &&
		css`
			border-top: 1px solid ${vr.borderGrey};
		`}

	${({ hasBorderBottom }) =>
		!!hasBorderBottom &&
		css`
			border-bottom: 1px solid ${vr.borderGrey};
		`}

	${({ customCss }) =>
		!!customCss &&
		css`
			${customCss};
		`}
`;
